import { z } from 'zod';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { Validation } from '@mews/framework';
import { useCurrentAccountingEnvironment } from '../../hooks/useCurrentAccountingEnvironment';

export const useDetailsSchema = () => {
    const { defaultLanguageCode } = useCurrentEnterprise();
    const accountingEnvironment = useCurrentAccountingEnvironment();
    return z.object({
        names: Validation.Localized.Required(defaultLanguageCode),
        shortNames: Validation.Localized.Optional(),
        descriptions: Validation.Localized.Optional(),
        externalNames: Validation.Localized.Optional(),
        productCategoryId: z.string().nullish(),
        ordering: Validation.Number.MaxInteger.default(0).nullish(),
        units: accountingEnvironment.useBillingUnits
            ? Validation.Localized.Required(defaultLanguageCode)
            : Validation.Localized.Optional(),
        image: Validation.File.Image({
            sizeLimit: {
                bytes: 5 * 1024 * 1024,
                text: '5MB',
            },
        }).nullish(),
        imageId: z.string().nullish(),
        externalIdentifier: z.string().max(70).nullish(),
    });
};

export type DetailsFormValues = z.input<ReturnType<typeof useDetailsSchema>>;
